import axios from 'axios';

const basePath = 'https://instasolv.com:3500';

function getReport(params) {    
    return axios.get(basePath + '/report?' + getQueryParam(params))
        .then((response) => {
            return response.data
        })
}


function getDetailReport(params){
    return axios.get(basePath + '/report/detail?' + getQueryParam(params))
        .then((response) => {
            return response.data
        })
}

function getQueryParam(params){
    var query = '';
    for (var key in params) {
        if (params[key] !== 'select' && params[key] != '')
            query += key + "=" + params[key] + "&"
    };
    return query.substring(0, query.length - 1);
}
export const reportServices = {
    getReport,
    getDetailReport
};